import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';
import { LongDateFormatKey } from 'moment';

/**
 * @ngModule SharedModule
 * @whatItDoes Formats a date as 2 digit month, 2 digit day and 4 digit year using locale rules.
 * @howToUse `date_expression_in_ISO8601_format | ultishortdate]`
 * @description
 *
 * Use `ultishortdate` to format a UTC date with 2 digit month, day and 4 digit year.
 *
 * ### Examples
 *
 *  Time	                                    'LT'	  8:30 PM
 *  Time with seconds	                        'LTS'	  8:30:25 PM
 *  Month numeral, day, year	                'L'	    09/04/1986
 *                                            'l'	    9/4/1986
 *  Month name, day, year	                    'LL'	  September 4, 1986
 *                                            'll'	  Sep 4, 1986
 *  Month name, day, year, time	              'LLL'	  September 4, 1986 8:30 PM
 *                                            'lll'	  Sep 4, 1986 8:30 PM
 *  Month name, day, day of week, year, time	'LLLL'	Thursday, September 4, 1986 8:30 PM
 *                                            'llll'	Thu, Sep 4, 1986 8:30 PM
 *  Other supported formats: https://momentjs.com/docs/#/displaying/format/
 */
@Pipe({
  name: 'ultishortdate'
})
export class UltiShortDatePipe implements PipeTransform {

  constructor(@Inject(LOCALE_ID) private _locale: string) {
    moment.locale(_locale);
  }

  /**
   * Transform operator of the pipe.
   * @param dateString the dateString to parse in UTC ISO-8601 format. e.g. "2019-03-06T05:00:00Z"
   * @param format See examples of UltiShortDatePipe.
   * @param displayUtc Whether or not to force display as utc time (as opposed to locale time).
   */
  transform(dateOrString: string, format: LongDateFormatKey, displayUtc = true): string {
    if (!dateOrString) {
 return '';
}

    let mDate = moment.utc(dateOrString, moment.ISO_8601);
    if (!displayUtc) {
      mDate = mDate.local();
    }
    const result = mDate.format(format);
    if (result === 'Invalid Date') {
      console.warn('An invalid date was passed to the ultishortdate pipe. Use ISO-8601 format.');
    }
    return result;
  }
}
